<template>
  <div class="layout-category-page">
    <layout-loader v-show="loading"/>
    <div class="container">
      <div class="breadcrumb-sorted-block">
        <ui-breadcrumbs></ui-breadcrumbs>
      </div>
      <div class="header">
        <div class="great-title">
          <h1>{{ titlepage }}</h1>
        </div>
      </div>
      <div class="sort" v-if="productcount">
        <div class="sorted">
          <select v-model="sorted" @change="onChangeSorted('sorted')">
            <option value="asc">
              <span>
               {{ this.$store.state.langs.SORT_BY }}
              </span>
            </option>
            <option value="asc">
              <span>
               {{ this.$store.state.langs.LOW_HIGH }}
              </span>
            </option>
            <option value="desc" >
              <span>
                {{ this.$store.state.langs.HIGH_LOW }}
              </span>
            </option>
          </select>
        </div>
        <div class="filters-button" @click="opened = !opened">
          <img v-if="!opened" src="@/assets/icons/filters.svg" alt="filters" :width="18" :height="18" />
          <img v-else src="@/assets/icons/close.svg" alt="close" />
          <span class="filters-button--text">
            {{this.$store.state.langs.FILTERES}}
          </span>
        </div>
      </div>
    </div>
    <div class="container" :class="[{ layout: Number(filter.PROPERTY_COUNT) }]">

      <div class="products">
        <layout-product-card
                v-for="(product, i) in products" :key="product"
                :product="product"
        >
        </layout-product-card>

        <div v-if="noProduct">
          {{this.$store.state.langs.NO_PRODUCTS}}
        </div>

      </div>
      <div v-if="( ( opened && width<769 ) || ( width>768 ) ) && Number(filter.PROPERTY_COUNT)" class="filter-wrapper">
        <div class="filters" :class="[{ opened }]">
          <vuescroll :ops="ops">
            <div v-for="(item, key, index) in filter.ITEMS" v-if="item.DISPLAY_TYPE" :class="[item.DISPLAY_TYPE=='F' ? 'ui-filter-checkbox' : item.DISPLAY_TYPE=='P' ? 'ui-filter-select' : '', index > openedFilters ? 'hidden' : '']" :name="item.NAME">
            <label class="xs-title">{{ item.NAME }}</label>
            <multiselects
                    select-Label=" "
                    selected-Label=" "
                    deselect-Label=" "
                    v-model="value[item.ID]"
                    :options="item.VALUES"
                    :searchable="false"
                    :custom-label="customLabel"
                    :multiple="true"
                    :close-on-select="false"
                    :show-labels="true"
                    :placeholder="item.NAME"
                    track-by="VALUE"
                    @remove=onRemove($event)
            >
              <label slot="option" slot-scope="scope" :for="scope.option.CONTROL_ID" class="filter-label-input" :class="[{disabled: scope.option.DISABLED}]">
                        <input
                                :disabled="scope.option.DISABLED ? true : false"
                                :checked="scope.option.CHECKED ? true : false"
                                :data-code="item.CODE"
                                :data-control_id="scope.option.CONTROL_ID"
                                :data-url_id="scope.option.URL_ID"
                                :id="scope.option.CONTROL_ID"
                                :name="scope.option.CONTROL_NAME"
                                type="checkbox"
                                class="checkbox-event"
                                :value="scope.option.HTML_VALUE"
                                v-on:change="filterCheck('product')"
                        >
                        <span class="small-text" v-html="scope.option.VALUE"></span>
                      </label>
              </multiselects>
            <!--<div v-if="item.DISPLAY_TYPE=='F'" class="checkboxes">
              <label v-for="itemCheckbox in item.VALUES" :for="itemCheckbox.CONTROL_ID" :class="itemCheckbox.DISABLED ? 'disabled' : ''">
                <input
                        :disabled="itemCheckbox.DISABLED ? true : false"
                        :checked="itemCheckbox.CHECKED ? true : false"
                        :data-code="item.CODE"
                        :data-control_id="itemCheckbox.CONTROL_ID"
                        :data-url_id="itemCheckbox.URL_ID"
                        :id="itemCheckbox.CONTROL_ID"
                        :value="itemCheckbox.HTML_VALUE"
                        :name="itemCheckbox.CONTROL_NAME"
                        type="checkbox"
                        v-on:change="filterCheck('product')"
                        class="checkbox-event"
                >
                <span class="small-text" v-html="itemCheckbox.VALUE"></span>
              </label>
            </div>

            <select v-if="item.DISPLAY_TYPE=='P'" v-on:change="filterCheck('product')">
              <option data-code="" data-control_id="" data-url_id="" id="all" value="">{{this.$store.state.langs.ALL}}</option>
              <option v-for="itemSelect in item.VALUES"
                      :disabled="itemSelect.DISABLED ? true : false"
                      :checked="itemSelect.CHECKED ? true : false"
                      :data-code="item.CODE"
                      :data-control_id="itemSelect.CONTROL_ID"
                      :data-url_id="itemSelect.URL_ID"
                      :id="itemSelect.CONTROL_ID"
                      :value="itemSelect.VALUE"
              >
                {{itemSelect.VALUE}}
              </option>
            </select>
-->
          </div>
          </vuescroll>
          <div v-if="openedFilters && width>768" class="blockButtons">
            <ui-button class="reset-filters" @click="reset">
              {{this.$store.state.langs.RESET_FILTERS}}
            </ui-button>
          </div>
        </div>

        <div v-if="openedFilters && opened && width<769" class="container blockButtons">
          <ui-button class="reset-filters" @click="reset">
            {{this.$store.state.langs.RESET_FILTERS}}
          </ui-button>

          <ui-button class="more" @click="scrolls(); opened = !opened">
            <span>{{this.$store.state.langs.VIEW}} {{this.productcount}}</span>
          </ui-button>
        </div>
        <div v-if="openedFilters && opened && width<769" class="closeFilters" @click="scrolls(); opened = !opened">
          <img src="@/assets/icons/close-grey.svg" alt="close" />
        </div>

      </div>
    </div>
    <div v-html="seoText" class="seotext viewer-hide-xs-down"></div>

  </div>
</template>

<script>
    import lodash from 'lodash';
    import uiBreadcrumbs from '@/components/ui/ui-breadcrumbs'
    import multiselects from '@/components/Multiselects'
    export default {
        components: {
            multiselects,
            uiBreadcrumbs,
            lodash
        },
        props: {
            openedFilters: {
                type: Number,
                default() {
                    return 10
                }
            },
            titlepage: "",
            seoText: "",
            paramsFilter: {},
            request: {}
        },
        data() {
            return {
                loading: true,
                opened: false,
                filter: {},
                products: {},
                products876: {},
                filterHtml: undefined,
                page: 1,
                pagen: 1,
                scroll: true,
                scrollTop: 0,
                scrollUp: false,
                scrollBig200: false,
                scrollFlag: false,
                scroll4: false,
                sorted: "asc",
                pagecount: 0,
                productcount: 0,
                noProduct: false,
                width: window.innerWidth,
                moreButton: false,
                value: {},
                ops: {
                    vuescroll: {},
                    scrollPanel: {},
                    rail: {
                        background: '#000',
                        opacity: 0.1,
                        size: '3px',
                        specifyBorderRadius: '0px'
                    },
                    bar: {
                        background: '#000',
                        opacity: 1,
                        size: '3px'
                    }
                },
            }
        },
        mounted() {
            //if(this.paramsFilter.SMART_FILTER_PATH) return;
          //var nodeObj = document.querySelector('.button-node');
          //nodeObj.scrollIntoView({behavior:"smooth",block:"start"});
            document.querySelector('.doH1').remove();
        },
        methods:{
            onChangeSorted(){
                this.filterCheck('product');
            },
            setScrollTrue() {
              this.scroll=true;
            },
            filterCheck(ev) {
              this.loading = true;
              
              if(ev=="product" || ev=="reset"){
                  this.page=1;
              }else{
                this.page++;

                if (this.page > this.pagecount) {
                  this.loading = false;
                  return;
                }

              } 

              var param = "";
              var paramFirst = "filter/";
              const filtersChecked = this.$el.querySelectorAll('.filters :checked');
              filtersChecked.forEach((filter, index) => {
                  if( ev!="reset" && filter.dataset.code!="" && filter.dataset.url_id!="") {
                      param += filter.dataset.code.toLowerCase() + '-is-' + filter.dataset.url_id + '/';
                  }
              })
              if(param.length>0){
                  param = paramFirst+param;//+"apply/";
              }else if(this.paramsFilter.SEF_RULE.length>0){
                  //param = this.paramsFilter.SMART_FILTER_PATH;
                  param = '';
              }
              this.request.param = param;
              // window.history.replaceState({}, '', `${this.paramsFilter.SEF_RULE}${param}`);
              window.history.pushState(
                  {"reload":param.length}, '', `${this.paramsFilter.SEF_RULE}${param}`);
              this.$axios({
                  url: '/ajax/category.php', method: 'post', data: { sort:this.sorted, request:this.request,paramsFilter:this.paramsFilter,pagen:this.pagen,page:(ev=='pagination') ? this.page : 1  }
              }).then(response => {
                  this.setScrollTrue();
                
                  if (response.status == 200) {
                      if(ev=='pagination') {
                          this.products = this.products.concat.apply(this.products, response.data.section);
                      }else{
                          this.filter = response.data.filter;
                          if(response.data.filter && response.data.filter.ITEMS){
                              let obFilter = response.data.filter.ITEMS;
                              this.value={};
                              obFilter.forEach((el) => {
                                  let elAr = [];
                                  el.VALUES.forEach((elV) => {
                                      if(elV.CHECKED){
                                          elAr.push(elV);
                                      }
                                  });
                                  if(elAr.length>0){
                                      this.value[el.ID]=[];
                                      this.value[el.ID]=elAr;
                                  }
                              });
                          }
                          this.products = response.data.section;
                      }

                      this.pagecount = parseInt(response.data.pagecount);
                      this.productcount = parseInt(response.data.productcount);
                      if(this.page>=parseInt(response.data.pagecount)){
                          this.moreButton = false
                          this.pagecount=0;
                      }else{
                          this.moreButton = true
                      }
                      this.loading = false;
                  }
                  
              }).catch(e => {
                  console.log('Error: ' + e)
              })
            },
            autoPagination: function() {
                const scrollTop = document.documentElement.scrollTop;
                const wievPortHeight = window.innerHeight; //высота окна
                const totallHeight = document.documentElement.offsetHeight-200; //полная высоа
                //блок список товаров
                const blockListProduct = document.querySelector('.products');
                //const  atTheButton = scrollTop + wievPortHeight >= totallHeight;
                const  atTheButton = scrollTop >= blockListProduct.offsetHeight-600;

                if( scrollTop > this.scrollTop ){
                    this.scrollTop = scrollTop;
                    this.scrollUp = true;
                }else{
                    this.scrollTop = scrollTop;
                    this.scrollUp = false;
                }

                if( atTheButton && this.scroll && this.scrollUp ){
                    this.scroll=false;
                    this.filterCheck('pagination');
                }
            },
            reset: function() {
                this.$el.querySelectorAll('.filters').checked=false;
                this.value={};
                this.filterCheck('reset');
            },
            updateWidth() {
                this.width = window.innerWidth;
            },
            scrolls(){
                let layoutCategoryPage = document.querySelector('.layout-category-page');
                layoutCategoryPage.scrollIntoView();
            },
            customLabel (option) {
                return `${option.VALUE}`
            },
            onRemove (option) {
                document.getElementById(option.CONTROL_ID).checked=false;
                this.filterCheck('product');
            }
        },
        created () {
          window.history.scrollRestoration = 'manual';
          this.$axios({
            url: '/ajax/category.php', method: 'post', data: { sort:this.sorted, request:this.request,paramsFilter:this.paramsFilter }
          }).then(response => {
            if (response.status == 200) {
              //console.log("response", response)
              if(response.data.filter && response.data.filter.ITEMS){
                this.filter = response.data.filter;
                let obFilter = response.data.filter.ITEMS;
                this.value={};
                obFilter.forEach((el) => {
                  let elAr = [];
                  el.VALUES.forEach((elV) => {
                    if(elV.CHECKED){
                      elAr.push(elV);
                    }
                  });
                  if(elAr.length>0){
                    this.value[el.ID]=[];
                    this.value[el.ID]=elAr;
                  }
                });
              }
              window.scrollTo(0, 1);

              let secElem = response.data.section;
              window.addEventListener('scroll', () => {
                //если мобила и больше 200 прокрутили и отметки нет о исполнении
                if (!this.scrollFlag && !this.scrollBig200 && this.width<768 && pageYOffset > 200) {
                  this.products = secElem;
                  this.scrollBig200=true;
                }else if(!this.scrollFlag && !this.scroll4 && this.width<768 ){
                  this.products = secElem.slice(0, 4);
                  this.scroll4=true;
                }else if(!this.scrollFlag && this.width>767 ){
                  this.products = secElem;
                  this.scrollFlag=true;
                }
              });
              if( !this.scrollBig200 && !this.scroll4 && !this.scrollFlag ){
                this.products = secElem;
                this.scrollFlag=true;
              }

              this.pagen = parseInt(response.data.pagen);
              this.productcount = parseInt(response.data.productcount);
              //this.page++;
              this.pagecount = parseInt(response.data.pagecount);
              if(this.page>=parseInt(response.data.pagecount)){
                this.moreButton = false
              }else{
                this.moreButton = true
              }
              if( this.productcount < 1 ){
                this.noProduct = true;
              }
              this.loading = false;

              //let lgJsonScript = document.createElement('script');
              //lgJsonScript.setAttribute('type', 'application/ld+json');
              //lgJsonScript.innerHTML =  JSON.stringify( response.data.lgjson );
              //document.head.appendChild(lgJsonScript)

            }
          }).catch(e => {
            console.log('Error: ' + e)
          })

            let delayedHandler = lodash.debounce(this.autoPagination, 100);
            window.addEventListener('scroll', delayedHandler);
            window.addEventListener('resize', this.updateWidth);
            window.addEventListener('popstate', event => {
            document.location.reload();

              if(event!=null && event.state!=null && event.state.reload!=null){
                //this.filterCheck('product');
                //history.go (0);
                //document.location.reload();
              }
            }
          );
        },
        updated() {
         // console.log('updated');
         // window.scrollTo(0, 1);
        },
        beforeCreate() {
          //console.log('beforeCreate');
        },
        computed: {
            moredetail() {
                return this.$store.state.langs.MORE_DETAILS
            }
        },
        watch: {
            opened: function (res) {
               /// document.querySelector('body').overflow='hidden';
                console.log('res',res);
            },
        }

    }
</script>

<style lang="scss" scoped>
  .layout-category-page {
    padding-bottom: 5em;
  }
  .layout {
    display: grid;
    grid-template-columns: auto 16em;
    grid-gap: 8.75em;
    align-items: flex-start;
    position: relative;
  }
  .products {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 2em 1.5em;
    padding-bottom: 30px;
  }
  .header {
    margin-bottom: 1em;
  }
  .info-pagination{
    color: #9a9a9a;
    margin-top: 5px;
  }
  .sort{
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .filters {
    // position: sticky;
    position: relative;
    &.opened {
      & > *.hidden {
        display: block;
      }
    }
    // top: 7em;
    & > * {
      &.hidden {
        display: none;
      }
      &:not(:last-child) {
       /* border-bottom: solid 1px rgba(0, 0, 0, 0.1);
        margin-bottom: 1.5em;*/
        padding-bottom: 1.5em;
      }
    }
    .ui-button{
      border-bottom: 2px solid;
    }
  }
  .filter-label-input{
    .disabled{
      text-decoration: line-through;
    }
  }
  .close {
    display: none;
  }
  .blockButtons{
    display: flex;
    justify-content: space-evenly;
  }
  .filters-button {
    display: none;
  }
  .ui-button.reset-filters {
    margin-top: 1em;
    padding: 1em 0;
    width: 100%;
    margin-right: 5px;
  }
  .ui-button.more {
    margin-top: 1em;
    background: #000;
    color: #fff;
    border: 2px solid #000;
    width: 100%;
    margin-left: 5px;
    padding: 1em 0;
  }
  .seotext{
    padding: 70px;
  }
  .closeFilters{
    height: 10px;
    width: 10px;
    position: fixed;
    top: 15px;
    right: 15px;
    display: flex;
    justify-content: flex-end;
    z-index: 1001;
  }
  @media screen and (max-width: 767px) {
    .layout {
      display: block;
    }
    .ui-button.reset-filters {
      padding: 1em 2em;
    }
    .ui-button.more {
      padding: 1em 2em;
    }
    .products {
      justify-content: center;
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
/*      grid-template-columns: repeat(2, 1fr);*/
    }
    .filters {
      position: fixed;
      width: 100%;
      background: #fff;
      top: 0;
      padding: 3em 2em;
      box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
      opacity: 0;
      visibility: hidden;
      transition: 0.5s;
      transform: translate(0, 2em);
      z-index: 1000;
      height: 100%;
      overflow-y: auto;
      padding-bottom: 60px;
      margin-left: -20px;
      &.opened {
        transform: translate(0, 0);
        opacity: 1;
        visibility: visible;
      }
    }
    .filters-button--text{
      padding: 0 10px;
    }
    .close {
      display: flex;
      justify-content: flex-end;
    }
    .filters-button {
      display: flex;
      align-items: center;
    }
    .great-title {
      display: flex;
      // align-items: center;
      justify-content: space-between;
    }
    .blockButtons{
      position: fixed;
      bottom: 0px;
      left: 0;
      right: 0;
      background: #fff;
      z-index: 1000;
    }
  }
  .moreListBlock{
    text-align: center;
  }
  .moreListBlock button{
    font-size: 1.2em;
    padding: 1em 2em;
    box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
    background: #f6f6f6;
  }
  .sort select{
    display: inline-block;
    /*width: 80px;*/
    height: 35px;
    border: none;
    background: #fff;
  }
</style>
<style>
  .seotext p{
    padding: 5px 0;
  }
  .seotext h2{
    font-size: 24px;
    text-align: center;
    padding: 10px 0px;
  }
  .seotext  h3{
    font-size: 18px;
    text-align: center;
    padding: 10px 0px;
  }
</style>
